import React from 'react';
import { useDrag, useDrop } from 'react-dnd'
import { flexRender, Row } from '@tanstack/react-table';
import { DraggableRowProps } from '../Table.types';

export default function DraggableRow({ row, reorderRow, isDragIconShow, onHoverShow }: DraggableRowProps) {
    const [, dropRef] = useDrop({
        accept: 'row',
        drop: (draggedRow: Row<{}>) => reorderRow(draggedRow?.index, row?.index)
    });

    const [{ isDragging }, dragRef, previewRef] = useDrag({
        collect: (monitor) => ({
            isDragging: monitor?.isDragging(),
        }),
        item: () => row,
        type: 'row'
    });
        
    return (
        <tr 
            className="tr h--100" 
            key={row.id} 
            ref={previewRef} 
            style={{ opacity: isDragging ? 0.5 : 1 }}
            onMouseEnter={() => onHoverShow!(true)}
            onMouseLeave={() => onHoverShow!(false)}
        >
            {row.getVisibleCells().map((cell: any) => {                                                                        
                return (
                    <td 
                        key={cell.id} 
                        className="td h--100 relative" 
                        style={{ 
                            borderRight: '1px solid rgba(144, 164, 183, 0.22)', 
                            borderBottom: '1px solid rgba(144, 164, 183, 0.22)',
                        }}
                    >
                        {(isDragIconShow && cell?.column.id === 'select') && (
                            <span 
                                ref={dropRef} 
                                className={`drag-drop pointer ${isDragIconShow ? 'show' : '' }`}
                                onMouseEnter={() => onHoverShow!(true)}
                                onMouseLeave={() => onHoverShow!(false)}
                                style={{ float: cell.column.id === 'select' ? 'right' : 'none', display: 'flex',  marginRight: '20px' }}
                            >
                                <button className='' ref={dragRef}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" style={{ fill: 'rgb(99, 115, 129)', transform: ';msFilter:' }}>
                                        <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"></path>
                                    </svg>
                                </button>
                            </span>
                        )}
                            
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                )
            })}
    </tr>
      )
}